document.addEventListener('DOMContentLoaded',function(){
  var home=document.querySelector('.lv-homepage');
  if(home){
    var selector=home.querySelector('.lv-selector');
    if(selector&&!home.querySelector('.lv-instructor-rental')){
      var block=document.createElement('aside');
      block.className='lv-instructor-rental lv-ecard-box';
      block.innerHTML='<div><div class="lv-kicker">For instructors</div><h3>Need training equipment without building your own inventory?</h3><p>Qualified instructors can request Limen Vitalis training-equipment rentals and support for their own classes. Availability and eligibility are confirmed for each request.</p><p><a class="lv-text-link" href="/pages/instructor-network">Instructor network</a></p></div><div><a class="lv-btn lv-btn-primary" href="/pages/instructor-equipment-rentals">Explore instructor rentals</a></div>';
      selector.appendChild(block);
    }
  }

  var footer=document.querySelector('footer.footer, .footer');
  if(footer&&!footer.querySelector('.lv-rental-footer-link')){
    var link=document.createElement('p');
    link.className='lv-rental-footer-link';
    link.innerHTML='<a href="/pages/instructor-equipment-rentals">Instructor equipment rentals</a>';
    footer.appendChild(link);
  }
});
